// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Custom components
import TemplateItem from 'components/TemplatePreview/TemplateItem';

// Styled
import { BodyWrapper, TemplatePreview } from './styled';

// Utils
import { ChecklistItemType } from 'pages/TemplateDashboard/context';
import { SubmissionItemType } from 'pages/TemplateDashboard/Tabs/Submissions/context';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConnectIcon from 'components/Icons/connectIcon';
import ConnectorIcon from 'components/Icons/connectorIcon';
import { STEP_TYPES } from 'utils/templates';

interface SectionAccordionProps {
  item: any;
  isEmulatorView: boolean;
}

const SectionAccordion = ({
  item,
  isEmulatorView,
  parentSection,
}: SectionAccordionProps) => {
  return (
    <Box
      sx={{
        ...(parentSection && {
          marginLeft: '8px',
        }),
      }}
    >
      <Accordion
        key={item.id}
        className="sectionAccordion"
        TransitionProps={{ unmountOnExit: true }}
        defaultExpanded
        disableGutters
        square={false}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="expandIcon" />}
          aria-controls="panel-content"
          className="sectionAccordionSummary"
        >
          {parentSection ? (
            <Stack direction="column" gap="5px">
              <Typography className="parentSectionTitle">
                {parentSection?.title}
              </Typography>
              <Stack direction="row" gap="3px">
                <ConnectIcon className="connectIcon" />
                <Typography className="headerTitle">{item.title}</Typography>
              </Stack>
            </Stack>
          ) : (
            <Typography className="headerTitle">{item.title}</Typography>
          )}
        </AccordionSummary>
        <AccordionDetails sx={{ px: 0, pb: 0 }}>
          {[...(item?.ChecklistItems || [])]
            ?.sort((a, b) => a.order - b.order)
            ?.map((checklistItem) => (
              <Box key={checklistItem.id} className="checklistItemCnt">
                <TemplateItem
                  item={checklistItem}
                  isEmulatorView={isEmulatorView}
                />
              </Box>
            ))}

          {[...(item?.subSections || [])]
            ?.sort((a, b) => a.order - b.order)
            ?.map((subSection) => {
              return (
                <SectionAccordion
                  key={subSection.id}
                  item={subSection}
                  isEmulatorView={isEmulatorView}
                  parentSection={item}
                />
              );
            })}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

const TemplateBody = ({
  checklistItems = [],
  checklistHash,
  isEmulatorView = false,
}: {
  checklistItems?: ChecklistItemType[] | SubmissionItemType[] | undefined;
  isEmulatorView?: boolean;
  checklistHash?: any;
}) => {
  return !isEmulatorView ? (
    <BodyWrapper>
      <TemplatePreview>
        {checklistItems
          ?.filter((item) => !item.ParentId && item.isActive)
          ?.map((item) =>
            item?.type === STEP_TYPES.HEADER ? (
              <SectionAccordion
                key={item.id}
                item={item}
                isEmulatorView={isEmulatorView}
              />
            ) : (
              <Box key={item.id} className="checklistItemCnt">
                <TemplateItem item={item} isEmulatorView={isEmulatorView} />
              </Box>
            ),
          )}
      </TemplatePreview>
    </BodyWrapper>
  ) : (
    <BodyWrapper
      sx={{
        ...(isEmulatorView && {
          gap: '10px',
        }),
      }}
    >
      {checklistItems
        ?.filter((item) => !item.ParentId && item.isActive)
        ?.map((item) => (
          <TemplateItem
            checklistItems={checklistItems}
            key={item.id}
            item={item}
            isEmulatorView={isEmulatorView}
            checklistHash={checklistHash}
          />
        ))}
    </BodyWrapper>
  );
};

export default TemplateBody;
